import Schema from '@data-driven-forms/react-form-renderer/dist/cjs/schema';
import { DBFormSchema, fieldLoginInput } from '..';

export const getForgotPasswordFormSchema = (schema: DBFormSchema): Schema => ({
  title: 'forgot password form',
  fields: [
    fieldLoginInput('username', schema?.username, {
      sizes: { xs: 12 },
      className: 'reset-control-div',
      Placeholder: 'UserName',
      icon: 'fa-light fa-envelope text-secondary',
      validate: [
        {
          type: 'username'
        }
      ]
    })
  ].filter(Boolean)
});

// -----===[test schema]===-----
export const forgotPasswordFormSchema: DBFormSchema = {
  username: { label: 'username', required: true }
};
